var React = require('react');

function Rating (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"22","height":"22","fill":"none","key":0}),React.createElement("path",{"d":"M11.988,2.5,15.125,8.77l6.934,1.045-5,4.921,1.148,6.917-6.224-3.23-6.224,3.23,1.148-6.917-5-4.921L8.851,8.77Zm0,3.353L9.844,10.137l-4.738.714,3.413,3.363-.785,4.727,4.253-2.207,4.253,2.207-.785-4.727,3.413-3.363-4.738-.714Z","transform":"translate(-0.988 -1.498)","fill":"#fff","fillRule":"evenodd","key":1})]);
}

Rating.defaultProps = {"width":"22","height":"22","viewBox":"0 0 22 22"};

module.exports = Rating;

Rating.default = Rating;
